import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from 'components/Button'
import { ICON_TYPES } from 'components/Icon.v2'

/**
 * The video ended component
 * @param {Map} props.share - The share data
 * @param {Function} props.onClick - The replay button click handler
 * @param {Map} props.staticText - The static text
 * @param {Boolean} props.isPaused - The prop indicating if video is paused
 * @returns {JSX.Element} video ended component
 */
function SharePageV3VideoEnded (props) {
  const {
    share,
    onClick,
    staticText,
    isPaused,
  } = props

  const imageNoText = isPaused ? null : share.getIn(['content', 'imageNoText'])

  return (
    <div className="share-page-v3__video-ended">
      <div
        className="share-page-v3__video-poster"
        style={imageNoText ? { backgroundImage: `url(${imageNoText}}` } : null}
      >
        <div className="share-page-v3__video-overlay">
          {isPaused
            ? <Button
              className="share-page-v3__video-overlay-control"
              type={BUTTON_TYPES.ICON}
              onClick={onClick}
              icon={ICON_TYPES.PLAY}
            >
              {staticText.get('resume')}
            </Button>
            : <Button
              className="share-page-v3__video-overlay-control share-page-v3__video-overlay-control--replay"
              type={BUTTON_TYPES.ICON}
              onClick={onClick}
              icon={ICON_TYPES.REPLAY}
            >
              {staticText.get('replay')}
            </Button>
          }
        </div>
      </div>
    </div>
  )
}

export default SharePageV3VideoEnded
